var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRbotV3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100mm",
    height: "100mm",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.0381 2.5498)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73098 0 0 .73084 8.4151 2.3002)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m99.938 76.214c-0.18502 3.8891-0.7911 7.8969-1.8853 11.997 0 0-8.6088 25.681-37.402 33.064-4.4428 1.1336-9.3603 1.8325-14.792 1.938-40.737 0.79111-47.039-46.801-45.681-57.941 1.3579-11.153 1.9775-25.708 28.279-65.258-0.06601 0.59325-5.247 45.022 8.8989 65.245 0 0 9.8876 3.3618 20.566-14.831 10.679-18.193 0.98888-42.121 0.39555-42.912-0.56682-0.71192 43.558 27.896 41.62 68.699z",
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m53.993 40.012c-6.4863 6.8291-10.283 3.6914-10.283 3.6914s9.0966-17.007 9.2285-26.499c0.13253 0.23728 8.5033 14.963 1.0546 22.807z",
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m99.938 76.214c-0.18502 3.8891-0.7911 7.8969-1.8853 11.997 0 0-8.6088 25.681-37.402 33.064-4.4428 1.1336-9.3603 1.8325-14.792 1.938-40.737 0.79111-47.039-46.801-45.681-57.941 1.3579-11.153 1.9775-25.708 28.279-65.258-0.06601 0.59325-5.247 45.022 8.8989 65.245 0 0 28.252 40.262 62.529 10.995 0 0 0.02749-0.02756 0.05252-0.04z",
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m60.638 121.26c-4.4428 1.1336-9.3603 1.8325-14.792 1.938-40.737 0.791-47.039-46.801-45.681-57.942 1.3579-11.153 1.9775-25.708 28.279-65.258-0.34277 0.9624-35.978 102.26 32.194 121.26z",
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m53.993 40.012c-6.4863 6.8291-10.283 3.6914-10.283 3.6914 14.766-9.5712 9.3075-26.275 9.2285-26.499 0.13253 0.23728 8.5033 14.963 1.0546 22.807z",
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 1.5,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.368 0 0 1.3683 -14.958 -7.3702)",
    x: 71.191895,
    y: 94.662636,
    fill: "#000000",
    fontFamily: "Comfortaa",
    fontSize: "11.354px",
    strokeWidth: 0.28386,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariationSettings: "'wght' 700",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 71.191895,
    y: 94.662636,
    fontFamily: "Comfortaa",
    fontSize: "11.354px",
    strokeWidth: 0.28386,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariationSettings: "'wght' 700"
    }
  }, "v3")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbotV3);
export default __webpack_public_path__ + "static/media/rbot-v3.fb5f617cbf22b52070f746640ead3143.svg";
export { ForwardRef as ReactComponent };